import type { ConfigProviderProps } from 'antd/es/config-provider';

const textAreaConfig: ConfigProviderProps['textArea'] = {
  classNames: ({ props }) => ({
    root: props.disabled && props.variant === 'borderless' ? 'bg-disabled' : undefined,
  }),
};

export default textAreaConfig;
